import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CoursesView from './CoursesView';
import useExternalSettings from '../../hooks/useExternalSettings';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import { Creators as planProgressPSActions } from '@/domain/useCases/getPlanProgressPS';
import constants from './constants';

const CoursesViewController = () => {
  const { callProgressiveCertification, isProgressiveCertification } =
    useExternalSettings();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = `UTP + Portal | Cursos`;
    GoogleAnalytics.writeLog('Menu-Cursos', 'Menu');
    callProgressiveCertification();
    dispatch(planProgressPSActions.getPlanProgressPSClear());
    dispatch(planProgressPSActions.getPlanProgressPS());
    return () => {
      document.title = `UTP+ Portal | Universidad Tecnológica del Perú`;
    };
  }, []);
  const history = useHistory();

  const handlerRedirect = (route: any) => {
    history.push(`/${route}`);
  };

  const getCourseSections = (value: boolean) =>
    value
      ? constants.courseSections
      : constants.courseSections.filter(
          (section) => section.title !== 'Certificaciones progresivas'
        );
  return (
    <CoursesView
      handlerRedirect={handlerRedirect}
      courseSections={getCourseSections(isProgressiveCertification)}
      sectionHeader={constants.sectionHeader}
    />
  );
};

export default CoursesViewController;
